import React from 'react';
import Icon from '../../../components/AppIcon';

const PricingDetails = ({ pricing }) => {
  return (
    <div className="bg-card rounded-lg shadow-elevation-3 p-6 sticky top-24">
      <h2 className="font-heading text-2xl font-semibold text-foreground mb-6">
        Price Breakdown
      </h2>

      <div className="space-y-4 mb-6 pb-6 border-b border-border">
        <div className="flex justify-between items-center">
          <span className="font-body text-base text-muted-foreground">
            ${pricing?.dailyRate} × {pricing?.days} days
          </span>
          <span className="font-body text-base font-medium text-foreground">
            ${pricing?.subtotal?.toFixed(2)}
          </span>
        </div>

        {pricing?.discount > 0 && (
          <div className="flex justify-between items-center">
            <span className="font-body text-base text-success">
              Weekly discount ({pricing?.weeklyDiscount}%)
            </span>
            <span className="font-body text-base font-medium text-success">
              -${pricing?.discount?.toFixed(2)}
            </span>
          </div>
        )}

        <div className="flex justify-between items-center">
          <span className="font-body text-base text-muted-foreground">
            Cleaning Fee
          </span>
          <span className="font-body text-base font-medium text-foreground">
            ${pricing?.cleaningFee?.toFixed(2)}
          </span>
        </div>

        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-1">
            <span className="font-body text-base text-muted-foreground">
              Sales Tax (8.25%)
            </span>
            <div className="group relative">
              <Icon name="Info" size={14} color="var(--color-muted-foreground)" strokeWidth={2} />
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 p-2 bg-foreground text-background text-xs rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                Sales tax of 8.25% applied to rental and cleaning fee
              </div>
            </div>
          </div>
          <span className="font-body text-base font-medium text-foreground">
            ${pricing?.tax?.toFixed(2)}
          </span>
        </div>

        <div className="flex justify-between items-center">
          <span className="font-body text-base text-muted-foreground">
            Security Deposit
          </span>
          <span className="font-body text-base font-medium text-foreground">
            ${pricing?.securityDeposit?.toFixed(2)}
          </span>
        </div>
      </div>

      <div className="flex justify-between items-center mb-6 pb-6 border-b border-border">
        <span className="font-heading text-xl font-semibold text-foreground">
          Total
        </span>
        <span className="font-heading text-2xl font-bold text-primary">
          ${pricing?.total?.toFixed(2)}
        </span>
      </div>

      <div className="space-y-3">
        <div className="flex items-start space-x-2">
          <Icon name="Shield" size={18} color="var(--color-success)" strokeWidth={2} />
          <p className="font-body text-sm text-muted-foreground">
            Security deposit fully refundable upon return
          </p>
        </div>
        <div className="flex items-start space-x-2">
          <Icon name="Lock" size={18} color="var(--color-success)" strokeWidth={2} />
          <p className="font-body text-sm text-muted-foreground">
            256-bit SSL encrypted payment processing
          </p>
        </div>
        <div className="flex items-start space-x-2">
          <Icon name="CheckCircle2" size={18} color="var(--color-success)" strokeWidth={2} />
          <p className="font-body text-sm text-muted-foreground">
            Comprehensive insurance coverage included
          </p>
        </div>
        <div className="flex items-start space-x-2">
          <Icon name="CreditCard" size={18} color="var(--color-success)" strokeWidth={2} />
          <p className="font-body text-sm text-muted-foreground">
            Powered by Stripe - PCI DSS compliant
          </p>
        </div>
      </div>
    </div>
  );
};

export default PricingDetails;